<template>
  <v-container fluid class="systemsetting-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Setting Information</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Create New Setting</p>
                        <v-text-field
                          class="mb-4"
                          v-model="systemsetting.settingcode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Setting Code"
                          persistent-hint
                          single-line hint="Enter the Setting Code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="systemsetting.settingname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Setting Name"
                          persistent-hint
                          single-line hint="Enter the Setting name">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=items
                          v-model="systemsetting.settingtype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the Setting type">
                        </v-select>
                          <v-switch
                            v-model="systemsetting.settingstatus"
                            color="primary"
                            v-bind:label="systemsetting.settingstatus"
                            value="Active"
                          ></v-switch>
                        <div class="d-flex justify-end">

                        </div>
                        <div class="d-flex justify-center">
                        <v-btn
                            to="/systemsetting/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="createSystemSetting()">
                            Save
                          </v-btn>
                      </div>

                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      systemsetting: {
        settingstatus: 'Active'
      },
      items: ['Boolean', 'Dynamic', 'Number', 'String'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('SystemSetting', ['createSystemSettingRequest', 'getSystemSettingsRequest']),
    checkError(){
      if(!this.systemsetting.settingcode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.systemsetting.settingname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.systemsetting.settingtype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    createSystemSetting() {
      if(!this.checkError()) return;
      this.createSystemSettingRequest(this.systemsetting);
      this.getSystemSettingsRequest();
      router.push('/systemsetting/list');
    },
  },
  computed: {
    ...mapState('SystemSetting', ['isReceiving'])
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
